module.exports = __webpack_public_path__ + "img/邮箱.e75f5f69.png";